/**
 * withRecommendations
 * HOC for wrapping the provided component with RecommendationsProvider
 */

import React from 'react'

import RecommendationsProvider from './recommendations-provider'

export default function withRecommendations (WrappedComponent) {
  return function RecommendationsProviderHOC(props) {
    return (
      <RecommendationsProvider>
        <WrappedComponent {...props} />
      </RecommendationsProvider>
    )
  }
}
